import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "progress loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showLoader)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "progress-bar",
          role: "progressbar",
          style: _normalizeStyle(_ctx.loaderStyle),
          "aria-valuenow": "100",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }, null, 4)
      ]))
    : _createCommentVNode("", true)
}